import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 10000 } }

  connect() {
    this.dismissTimer = window.setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    window.clearTimeout(this.dismissTimer)
  }

  dismiss() {
    this.element.classList.add("is-dismissing")
    this.element.addEventListener("animationend", () => this.element.remove(), { once: true })
  }
}
